module.exports = __webpack_public_path__ + "static/media/download.c81ddd04.svg";